<template>
    <div class="login-container">
      <nav-bar :showBack="false"/>
      <van-form @submit="onSubmit">
        <div class="page-title"> {{$t('密码重置')}} </div>
        <pwd-input-view v-model="user.password" :placeholder="$t('请输入新密码')"/>
        <pwd-input-view v-model="user.confirmPassword" :placeholder="$t('请再次输入新密码')"/>
        <div class="password-tip"> {{$t('密码长度为6-20位，数字、字母、标点符号（除空格）至少包含两种')}}</div>
        <van-button class="login-btn" :disabled="!user.password || !user.confirmPassword" block type="info" native-type="submit" @touchstart="onFailed()">
          {{ $t('确定') }}
        </van-button>
      </van-form>
      <tip-popup-view v-model="tipShow" :tip-content="tipContent" :button-content="tipButton"/>
    </div>
  </template>
<script>
import { Icon, Form, Field, Button, CheckboxGroup, Checkbox, CountDown, Toast, Popup, Dialog } from 'vant'
import NavBar from '@/components/NavBar'
import TipPopupView from '@/components/TipPopupView'
import PageBase from '@/mixin/page-base'
import PwdInputView from '@/components/PwdInputView'
import { resetPwd } from '@/api/common/index'
import md5 from 'js-md5'

export default {
  mixins: [PageBase],
  components: {
    NavBar,
    TipPopupView,
    PwdInputView,
    [Icon.name]: Icon,
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [CheckboxGroup.name]: CheckboxGroup,
    [Checkbox.name]: Checkbox,
    [CountDown.name]: CountDown,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog
  },
  props: {},
  data () {
    return {
      user: {
        email: '',
        password: '',
        confirmPassword: ''
      },
      show: false,
      iframeLink: '',
      openEye: false,
      protocolFlag: false
    }
  },
  computed: {},
  watch: {},
  created () {
  },
  mounted () {
    this.initParamter()
  },
  methods: {

    onFailed () {

    },
    onSubmit () {
      const data = this.$store.getters.resetPwdParam

      if (!this.isValidPassword(this.user.password)) {
        Toast(this.$t('密码格式错误'))
        return
      }
      if (this.user.password !== this.user.confirmPassword) {
        Toast(this.$t('两次密码输入不一致'))
      }
      data.pwd = md5(this.user.password)
      data.newPwd = md5(this.user.confirmPassword)
      this.showLoading()
      resetPwd(data).then(res => {
        this.dismissLoading()
        if (res.code === 100) {
          Toast(res.desc)
          setTimeout(() => {
            this.$router.replace({ path: '/pwd-login', query: this.$route.query })
          }, 1000)
        } else {
          this.showTipPopup(res.desc, this.$t('确定'))
        }
      }).catch((error) => {
        this.dismissLoading()
        this.showTipPopup(error, this.$t('确定'))
      })
    }

  }
}
</script>
  <style scoped lang="less">
  .login-container {
    background: #ffffff;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    position: relative;
    padding: 0px 24px;
    .viomi-logo {
      width: 59px;
      height: 52px;
      margin-top: 28px;
      align-self: center;
    }
    .page-title {
      margin-bottom: 28px;
      font-size: 24px;
      font-weight: 500;
      color: #2C2C2C;
      align-self: center;
      text-align: center;
    }
    .password-tip {
        font-size: 12px;
        color: #999999;
        margin-top: 12px;
    }
    .custom-field {
      background-color: #F5F7FA;
      margin-top: 8px;
      border-radius: 8px;
      font-size: 14px;
    }
    .custom-field /deep/ .van-field__button {
      display: flex;
      align-items: center;
    }
    .custom-field /deep/ .van-field__control {
      border-bottom: none;
      height: 40px;
    }
    .forget-pwd {
      font-size: 12px;
      font-weight: 400;
      color: gray;
      align-self: flex-end;
      text-align: right;
      margin-top: 16px;
    }

    .input-desc {
      font-size: 10px;
      color: #999999;
      line-height: 20px;
      position: relative;
      opacity: 0;
    }
    .inputDescAct {
      opacity: 1;
      animation: myfirst 0.05s;
      -webkit-animation: myfirst 1s; /* Safari and Chrome */
    }
    @keyframes myfirst {
      0% {
        opacity: 0;
        left: 0px;
        top: 5px;
      }
      100% {
        opacity: 1;
        left: 0px;
        top: 0px;
      }
    }

    @-webkit-keyframes myfirst /* Safari and Chrome */ {
      0% {
        opacity: 0;
        left: 0px;
        top: 5px;
      }
      100% {
        opacity: 1;
        left: 0px;
        top: 0px;
      }
    }
    .send-sms-btn {
      height: 16px;
      line-height: 16px;
      font-size: 13px;
      color: #28beca;
    }
    .login-btn {
      margin-top: 16px;
      background: linear-gradient(90deg, #5fd1db 0%, #28beca 100%);
      border: none;
      border-radius: 8px;
      height: 48px;
      font-size: 14px;
      width:327px;
    }
    .countDownBlock {
      color: #ace6ebff;
      font-size: 13px;
    }
    .captchaImg {
      width: 80px;
    }
    .iframeBody {
      width: 100%;
      height: 100%;
    }
  }
  </style>
